import useMatchingVehiclesData from './useMatchingVehiclesData';

export default function useTotalMatchingVehicles(): number {
  return useMatchingVehiclesData().totalMatchingVehicles;
}
